<template>
    <transition name="modal-fade">
        <div class="modal-component-backdrop">
            <div class="modal-component  rounded-8" role="dialog" aria-labelledby="modalTitle"
                aria-describedby="modalDescription">
                <header class="modal-component-header bg-white text-primary" id="modalTitle">
                    <slot name="header">
                        <strong>Editar información</strong>
                    </slot>
                    <button type="button" class="btn btn-close bg-utel-v2-secondary text-primary" @click="close"
                        aria-label="Close modal">
                    </button>
                </header>

                <section class="modal-component-body px-4" id="modalDescription">
                    <slot name="body">
                        <div class="row col-12">
                            <small>Cambia los campos... y guarda.</small>
                        </div>
                        <div class="row col-md-6 mx-auto" v-if="empresa.photo">
                            <img :src="empresa.photo" class="img-fluid" ref="profilePhotoDisplay" style="max-height:130px;object-fit: contain;">
                        </div>
                        <div class="row col-12">
                            <span><b>Logo</b> 300x300 px en JPG, JPEG, PNG</span>
                            <input id="photo" v-on:change="attachImage" ref="profilePhoto" type="file" accept=".jpg, .jpeg, .png"
                                                class="rounded-8 form-control sin-borde text-primary" >
                        </div>
                        <div class="row col-12">
                            <input type="text" class="rounded-8 form-control sin-borde text-primary"
                                v-model="empresa.name" placeholder="Nombre de la empresa">
                        </div>
                        <div class="row col-12">
                            <input type="text" class="rounded-8 form-control sin-borde text-primary"
                                v-model="empresa.website" placeholder="URL Sitio web">
                        </div>
                        <div class="row col-12">
                            <label for="company-licence"><strong>Nivel del plan empresarial</strong></label>
                            <select @change="checkClientLicense($event, empresa.id)" v-model="empresa.license_id" id="company-licence"
                                class="form-control rounded-8 sin-borde text-primary">
                                <option value="" disabled selected>Seleccione una opción</option>
                                <option v-for="licence of licenses" :key="licence.id" :value="licence.id">
                                    {{ licence.name }}
                                </option>
                            </select>
                            <small style="color:red" v-if="licenseError">{{ licenseError }}</small>
                        </div>
                        <div class="row col-12">
                            <label for="client-etapa"><strong>Etapa de la empresa</strong></label>
                            <select v-model="empresa.etapa_empresa" class="form-control rounded-8 sin-borde text-primary"
                                id="client-etapa">
                                <option value="">Seleccione una opción</option>
                                <option value="free_trial">Free Trial</option>
                                <option value="pago">Pago</option>
                            </select>
                        </div>
                        <div class="row col-12">
                            <label for="client-tipo"><strong>Tipo de la empresa</strong></label>
                            <select v-model="empresa.tipo_empresa" class="form-control rounded-8 sin-borde text-primary"
                                id="client-tipo">
                                <option value="">Seleccione una opción</option>
                                <option value="empresa_interna">Empresa interna</option>
                                <option value="empresa_real">Empresa real</option>
                            </select>
                        </div>
                        <!-- <div class="row col-12">
                            <input type="text" class="rounded-8 form-control sin-borde text-primary" v-model="estudiante.lastname" placeholder="Apellido del usuario">
                        </div>
                        <div class="row col-12">
                            <select v-model="estudiante.role" class="rounded-8 form-control sin-borde text-primary">
                                <option v-for="r of roles" :key="r.id" :value="r.name"> {{ r.name }} </option>
                            </select>
                        </div> -->
                    </slot>
                </section>

                <footer class="modal-component-footer justify-content-center d-flex">
                    <slot name="footer">
                    </slot>
                    <button type="button" class="btn text-primary bg-utel-v2-secondary mx-3" @click="close"
                        aria-label="Close modal">
                        Cancelar
                    </button>
                    <button type="button" id="update-button" class="btn text-white bg-utel" @click="editCompany"
                        aria-label="Eliminar usuario">
                        Guardar cambios
                    </button>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['url', 'company', 'licenses', 'urlrevisarplan', 'urlupdatephoto' ],
    data() {
        return {
            empresa: { id: '', name: '', website: '', photo: '', license_id: '', etapa_empresa: '', tipo_empresa: '' },
            urlEditUser: this.url + "/" + this.company.id,
            error: [],
            licenseError: null
        }
    },
    mounted(){
        this.empresa.id = this.company.id;
        this.empresa.name = this.company.name;
        this.empresa.website = this.company.website;
        this.empresa.photo = this.company.photo;
        this.empresa.license_id = this.company.license_id;
        this.empresa.etapa_empresa = this.company.etapa_empresa;
        this.empresa.tipo_empresa = this.company.tipo_empresa;
    },
    methods: {
        close() {
            this.$emit('close');
        },
        editCompany(){
            if ( this.licenseError ) return;

            const btn = document.getElementById("update-button");
            btn.textContent = "Procesando ...";
            let context = this;
            axios
                .put(this.urlEditUser, this.empresa)
                .then((res) => {
                    btn.textContent = 'Guardar cambios';
                    context.$emit('reloadtable', true);
                    context.close();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        checkClientLicense(event, idCliente) {
            const value = event.target.value;

            axios.post(`${this.urlrevisarplan}?withUsers=true&idPlan=${value}&idCliente=${idCliente}`).then((res) => {
                this.licenseError = null
            }).catch((err) => {
                if (!err.response) return
                this.licenseError = err.response.data.message;
            });
        },
        attachImage() {
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }

            this.empresa.photo = this.$refs.profilePhoto.files[0];
            let reader = new FileReader();
            reader.addEventListener('load', function () {
                this.$refs.profilePhotoDisplay.src = reader.result;
            }.bind(this), false);
            reader.readAsDataURL(this.empresa.photo);

            var data = new FormData();
            data.append('file', this.empresa.photo);
            data.append('idClient', this.empresa.id);

            axios
                .post(this.urlupdatephoto, data, config)
                .then((res) => {
                    this.empresa.photo = res.data;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
    },
};
</script>

<style>
.modal-component-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-component {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
}

.modal-component-header,
.modal-component-footer {
    padding: 15px;
    display: flex;
}

.modal-component-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
}

.modal-component-footer {
    border-top: 1px solid #eeeeee;
    /*flex-direction: column;*/
    justify-content: flex-end;
    background: none !important;
}

.modal-component-body {
    position: relative;
    padding: 20px 10px;
}

/*
.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
}

.btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
}
*/
.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}</style>
